import { Component, h } from 'preact';
import { TcrMouseHandler } from './tcr-mouse';

class TcrMenuView extends Component
{
    constructor(props)
    {
        super(props);

        this.handleAction = this.handleAction.bind(this);
        this.setMeta = this.setMeta.bind(this);

        this.state = {
            meta: {}
        };
    }

    componentDidMount()
    {
        window.MenuView = {
            setMeta: this.setMeta
        };
    }

    componentWillUnmount()
    {
    }

    setMeta(index, value)
    {
        this.setState(prevState => {
            let meta = {
                ...prevState.meta
            };
            meta[index] = value;
            return {
                meta: meta
            }
        });
    }

    getCount(i, j)
    {
        let index = (i+1) + ':' + (j+1);
        //console.log('getCount', this.state.meta, index);
        if (this.state.meta.hasOwnProperty(index))
        {
            if (this.state.meta[index].count > 0)
            {
                return ' (' + this.state.meta[index].count + ')';
            }
        }
        return '';
    }

    handleAction(action, event)
    {
        //console.log('click more');
        event.stopPropagation();
        if (typeof action === 'function')
        {
            action(event);
        }
        if (typeof this.props.onClose === 'function')
        {
            this.props.onClose();
        }
    }

    render()
    {
        let rows = [];
        (this.props.menu || []).forEach((m,i) => 
        {
            if (m.visibility === false) return;

            let primaryAction;
            if (typeof m.action === 'function')
            {
                primaryAction = (e) => this.handleAction(m.action, e)
            }
            let secondaryAction;
            if (typeof m.secondaryAction === 'function')
            {
                secondaryAction = (e) => this.handleAction(m.secondaryAction, e)
            }
            const mh = new TcrMouseHandler(primaryAction, secondaryAction);
            if (m.add)
            {
                rows.push(
                    <div class="menu-item add" onClick={(e) => this.handleAction(m.action, e)}>
                        <div class="tcr-icon" data-icon="add"></div>
                        <div class="title">{m.title}</div>
                    </div>
                );
            }
            else if (m.search)
            {
                rows.push(
                    <div class="menu-item search" data-active={!!m.value}>
                        <div class="tcr-icon" data-icon="search"></div>
                        <input type="text" placeholder={m.placeholder} value={m.value} onInput={(e) => m.action(e.target.value)} />
                    </div>
                );
            }
            else if (m.separator)
            {
                rows.push(<div class="menu-item spacer"></div>);
            }
            else
            {
                if (m.separate)
                {
                    rows.push(<div class="menu-item spacer"></div>);
                }
                let icon = m.icon ? <div class="tcr-icon" data-icon={m.icon} style={{color: m.color || 'var(--foreground)'}}></div> : <div class="icon" style={m.color ? {backgroundColor: m.color} : {}}></div>;
                let context = (typeof m.secondaryAction === 'function') ? <div class="more" onClick={(e) => this.handleAction(m.secondaryAction, e)}><div></div></div> : undefined;
                let count = this.getCount(i,0);
                rows.push(
                    <div class="menu-item" data-active={m.active ? 'true' : 'false'} data-haze={m.haze} data-badge={m.badge} data-more={typeof m.secondaryAction === 'function'} onmousedown={mh.down} oncontextmenu={mh.none} onmouseup={mh.up} onmouseleave={mh.cancel} onmouseout={mh.cancel} ontouchstart={mh.down} ontouchend={mh.up} ontouchcancel={mh.cancel} ontouchmove={mh.move}>
                        {icon}
                        <div class="badge"></div>
                        <div class="title">{m.title}{count}</div>
                        {context}
                    </div>
                );
    
                (m.submenus || []).forEach((sm,j) => 
                {
                    if (sm === 'spacer')
                    {
                        rows.push(<div class="submenu-item spacer" data-collapsed={!m.active}></div>);
                        return;
                    }
    
                    let count = this.getCount(i,j);
                    rows.push(
                        <div
                            class="submenu-item" data-active={sm.active ? 'true' : 'false'}
                            data-path={sm.path}
                            data-shared={sm.shared}
                            data-collapsed={!m.active}
                            data-badge={sm.badge}
                            onClick={(e) => this.handleAction(sm.action, e)}
                        >
                            <div class="tcr-icon" data-icon="sharing"></div>
                            <span class="icon" style={sm.color ? {backgroundColor: sm.color} : {}}></span>
                            <div class="badge"></div>
                            <div class="count">{sm.count}</div>
                            {sm.title}{count}
                        </div>
                    );
                });
            }
        });
        return (
            <div class="menu-list">
                {rows}
            </div>
        );
    }
}

export { TcrMenuView };
